<!-- <div id="editor-cover">
  <div id="editorjs" class="shadow-notification cdx-block"></div>
</div> -->
<div>
  <section id="preview-editor" class="page__content" #previewEditor></section>
</div>
